const enums = {
    maintenanceEventStatus: ['Upcoming', 'Pending', 'Completed', 'Closed', 'Cancelled'],
    maintenanceEventActionItem: ['Mark_as_pending', 'Complete_Event', 'Close_Event', 'Cancel_Event'],
};

export default enums;
